<prcins-desktop-header [menus]="menus | async" [activeMenus]="activeMenus" [selectedHeader]="selectedHeader"
  (logOut)="onLogout()" (softLogOut)="onSoftLogout()"></prcins-desktop-header>
<prcins-mobile-header [menus]="menus  | async" [activeMenus]="activeMenus" [selectedHeader]="selectedHeader"
  (logOut)="onLogout()" (softLogOut)="onSoftLogout()"></prcins-mobile-header>
